// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"80":"localeAZ","994":"localeRU"}[chunkId] + "." + {"80":"577d7aeaa733ed72a3b9","994":"a9d0c64ff5365b4ef263"}[chunkId] + ".bundle.js";
};